import { BiAction, BiLocationObject, BiObjectName, BiObjectType } from '@core/services/logger/interfaces/bi.enums';
import { Bites } from '@modules/teeth-diagram/models/bites.enum';
import { IUserActionEvent } from '@core/services/logger/interfaces/bi.events';
import { UserActionArgs } from '@itero/observability';

export const restoMultiBiteClicked = (value: boolean, name: Bites): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: name,
	action: BiAction.Clicked,
	objectType: BiObjectType.CheckBox,
	selectedValue: String(!!value),
	automationId: ''
});

export const restoMultiBiteToggleClicked = (value: boolean): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.MultiBiteRestoScan,
	action: BiAction.Clicked,
	objectType: BiObjectType.ToggleButton,
	selectedValue: String(!!value),
	automationId: ''
});

export const sendUpdateAttachmentLater = (value: boolean): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.IsDraft,
	action: BiAction.Clicked,
	objectType: BiObjectType.ToggleButton,
	selectedValue: String(!!value),
	automationId: ''
});

export const registerForDesignSuit = (selectedValue: string, bannerType: string): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: bannerType,
	action: BiAction.Clicked,
	objectType: BiObjectType.Button,
	selectedValue,
	automationId: ''
});

export const palatalFeedbackToggleClicked = (value: boolean): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.PalatalScanningFeedback,
	action: BiAction.Clicked,
	objectType: BiObjectType.ToggleButton,
	selectedValue: String(value),
	automationId: ''
});

export const applianceOptionTypeClicked = (selectedValue: string): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.ApplianceOptions,
	action: BiAction.Clicked,
	objectType: BiObjectType.RadioButton,
	selectedValue,
	automationId: ''
});

export const orderTypeDropdownSelected = (selectedValue: string): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.OrderType,
	action: BiAction.Clicked,
	objectType: BiObjectType.DropdownList,
	selectedValue,
	automationId: ''
});

export const applianceOptionsArchClicked = (selectedValue: string): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.ApplianceOptionsArch,
	action: BiAction.Clicked,
	objectType: BiObjectType.RadioButton,
	selectedValue,
	automationId: ''
});

export const dentureOptionsArchClicked = (selectedValue: string): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.DentureOptionsArch,
	action: BiAction.Clicked,
	objectType: BiObjectType.RadioButton,
	selectedValue,
	automationId: ''
});

export const toothDiagramClicked = (selectedValue: string, teethNumber: number): IUserActionEvent => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.ToothDiagram,
	action: BiAction.Clicked,
	objectType: BiObjectType.RadioButton,
	selectedValue,
	automationId: String(teethNumber)
});

export const rxModeToggled = (selectedMode: boolean): UserActionArgs => ({
	locationParentObject: BiLocationObject.RxContainer,
	objectName: BiObjectName.RxModeSelector,
	action: BiAction.Toggle,
	objectType: BiObjectType.Switch,
	selectedValue: String(selectedMode)
});
